import { PillsInput, PillsInputProps } from 'components/PillsInput/PillsInput'
import { SnippetsProseToolbar } from '../SnippetsToolbar/SnippetsProseToolbar'
import { KnowledgeBaseSnippetKind } from 'types'
import { useMemo } from 'react'
import cx from 'classnames'
import Styles from './SnippetsPillsInput.module.scss'
import { Plugin } from 'prosemirror-state'

export interface SnippetPillsInputProps extends Omit<PillsInputProps, 'plugins' | 'isValid' | 'footer'> {
  isSingleLine?: boolean
}

export const SnippetsPillsInput = (props: SnippetPillsInputProps) => {
  const kinds = useMemo(() => [KnowledgeBaseSnippetKind.Keywords], [])
  return (
    <PillsInput
      {...props}
      isValid
      size="lg"
      plugins={{
        // No-op plugin so we don't load actual mentions plugin
        mentions: new Plugin({}),
      }}
      footer={(focused) => <SnippetsProseToolbar kinds={kinds} shown={focused} />}
      className={cx({ [Styles.isSingleLine]: !!props.isSingleLine })}
    />
  )
}
